import useFetchHeaderData from './use-fetch-header-data';
import { useGetRouteToIssuerPage } from '../../../../app/get-route-to-page';
import { Page } from '../../../../app/page-url-path';
import { useNavigationMenu } from '../../navigation-menu/hooks';
import { useGetPageConditionRequirementResults } from '../../../../app/pages-requiring-condition';

const useHeader = () => {
  const adminPageUrl = useGetRouteToIssuerPage(Page.ADMIN_PAGE);
  const isAdminPageAvailable =
    useGetPageConditionRequirementResults()[Page.ADMIN_PAGE];

  const {
    data: navigationMenu,
    loading: navigationMenuLoading,
    error: navigationMenuError,
  } = useNavigationMenu();

  const {
    data: headerData,
    loading: loadingHeaderSection,
    error: errorFetchingHeaderSection,
  } = useFetchHeaderData();

  return {
    headerData,
    navigationMenu,
    navigationMenuLoading,
    navigationMenuError,
    loadingHeaderSection,
    errorFetchingHeaderSection,
    adminPageUrl,
    isAdminPageAvailable,
  };
};

export default useHeader;
